import React from 'react';
import PropTypes from 'prop-types';
import { Player } from 'video-react';
import { VIDEO_WRAPPER_CLASS_NAME } from '../../../constants';

// import 'video-react/styles/scss/video-react.scss';

const Default = ({ modifier, url, autoplay, loop }) => (
  <div className={VIDEO_WRAPPER_CLASS_NAME}>
    <Player className={modifier} preload="none" autoPlay={autoplay} loop={loop} muted={autoplay}>
      <source src={url} />
    </Player>
  </div>
);

Default.propTypes = {
  url: PropTypes.string.isRequired,
  modifier: PropTypes.string,
  autoplay: PropTypes.bool,
  loop: PropTypes.bool
};

Default.defaultProps = {
  modifier: null,
  autoplay: false,
  loop: false
};

export default Default;
